import { render, staticRenderFns } from "./HomeworkAddStdbQuestion.vue?vue&type=template&id=84500266&scoped=true"
import script from "./HomeworkAddStdbQuestion.vue?vue&type=script&lang=js"
export * from "./HomeworkAddStdbQuestion.vue?vue&type=script&lang=js"
import style0 from "./HomeworkAddStdbQuestion.vue?vue&type=style&index=0&id=84500266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84500266",
  null
  
)

export default component.exports